module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-14-min.5ddf956c.jpg";